import React from "react"

class CampDirectEmails extends React.Component {
  render() {
    return <div>CAMP DIRECT EMAILS</div>
  }
}

export default CampDirectEmails



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampDirectEmails/index.js